import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  top: 7px;
  right: 16px;
  z-index: 1;
  height: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media ${({ theme }) => theme.queries.minTablet} {
    right: 24px;
  }

  @media ${({ theme }) => theme.queries.minDesktop} {
    top: 15px;
    right: 32px;
  }
`;
